import { atom } from 'recoil';

// Notification definition matching backend response
export interface TourNotification {
	id: string;
	tourId: string;
	active: boolean;

	// Trigger
	triggerType: 'mapEntry' | 'location' | 'locationAndAction' | 'action';
	triggerConfig: {
		stopId: string | null;
		location: { latitude: number; longitude: number } | null;
		radius: number;
		delay?: number; // Delay in seconds before showing the notification
	};

	// Display
	notificationType: 'message' | 'cta';
	displayOnce: boolean;
	showInList: boolean;
	title: string;
	content: string;
	icon: string;
	thumbnail: string | null;
	notificationScale: number;
	order: number;
	priority: 'high' | 'medium' | 'low';

	// CTA config (for cta type notifications)
	ctaConfig: {
		primaryButtonText?: string;
		secondaryButtonText?: string;
		actionType?: 'link' | 'navigate' | 'modal' | 'openStop';
		actionValue?: string; // URL for link, stop-id for navigate/modal/openStop
	} | null;

	// User state (from backend, per user)
	userState: {
		seen: boolean;
		seenOnList: boolean;
		dismissed: boolean;
		ctaClicked: boolean;
		firstSeenAt: string | null;
	};

	// Timestamps
	createdAt: { _seconds: number; _nanoseconds: number };
	updatedAt: { _seconds: number; _nanoseconds: number };
}

// Atom to hold notifications for the current tour
export const atom_tourNotifications = atom<TourNotification[]>({
	key: 'TourNotifications',
	default: [],
});

// ============ MESSAGE NOTIFICATIONS (Toast) ============
// Active message notification to display as toast
export const atom_activeMessageNotification = atom<TourNotification | null>({
	key: 'ActiveMessageNotification',
	default: null,
});

// Queue for message notifications
export const atom_messageNotificationQueue = atom<TourNotification[]>({
	key: 'MessageNotificationQueue',
	default: [],
});

// ============ CTA NOTIFICATIONS (List/Modal) ============
// Active CTA notification to display in list
export const atom_activeCTANotification = atom<TourNotification | null>({
	key: 'ActiveCTANotification',
	default: null,
});

// Queue for CTA notifications
export const atom_ctaNotificationQueue = atom<TourNotification[]>({
	key: 'CTANotificationQueue',
	default: [],
});

// ============ SHARED ============
// Track triggered notification IDs to prevent re-triggering (session-based)
export const atom_triggeredNotificationIds = atom<Set<string>>({
	key: 'TriggeredNotificationIds',
	default: new Set(),
});

